import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { Box, Paper, IconButton, TextField } from '@mui/material';
import { Image as ImageIcon, Delete } from '@mui/icons-material';

const ImageComponent = (props: any) => {
  const { node, updateAttributes, deleteNode } = props;
  const { url } = node.attrs;

  return (
    <NodeViewWrapper>
      <Paper
        elevation={2}
        sx={{
          p: 2,
          my: 2,
          backgroundColor: '#f5f5f5',
          border: '2px solid #4caf50',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <ImageIcon color="success" />
          <strong>Изображение</strong>
          <IconButton
            size="small"
            color="error"
            onClick={deleteNode}
            sx={{ ml: 'auto' }}
          >
            <Delete />
          </IconButton>
        </Box>
        <TextField
          fullWidth
          size="small"
          label="URL изображения"
          value={url || ''}
          onChange={(e) => updateAttributes({ url: e.target.value })}
          sx={{ mb: 1 }}
        />
        {url && (
          <Box
            component="img"
            src={url}
            alt="Content"
            sx={{
              maxWidth: '100%',
              height: 'auto',
              display: 'block',
              borderRadius: 1,
            }}
          />
        )}
      </Paper>
    </NodeViewWrapper>
  );
};

export const ImageBlock = Node.create({
  name: 'imageBlock',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      url: { default: '' },
      is_blur: { default: true },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="imageBlock"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ 'data-type': 'imageBlock' }, HTMLAttributes),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageComponent);
  },

  // @ts-ignore - Tiptap type issue with custom commands
  addCommands() {
    return {
      insertImageBlock:
        (attrs: { url?: string; is_blur?: boolean }) =>
        ({ commands }: any) =>
          commands.insertContent({
            type: this.name,
            attrs,
          }),
    };
  },
});
